<template lang="pug">
div(:class='{large: size === "large"}')
  div(v-if='!readyToEvolve && spriteDetails.evolution === 0')
    img(src='../../assets/sprite-1.svg', v-if='spriteDetails.freeType === 1 && !spriteDetails.tokenId')
    img(src='../../assets/sprite-2.svg', v-if='spriteDetails.freeType === 2 && !spriteDetails.tokenId')
    img(src='../../assets/sprite-3.svg', v-if='spriteDetails.freeType === 3 && !spriteDetails.tokenId')
    img(src='../../assets/sprite-4.svg', v-if='spriteDetails.freeType === 4 && !spriteDetails.tokenId')
    img(src='../../assets/baby-sprites/baby_sprite_white.svg', v-if='spriteDetails.tokenId % 6 === 0')
    img(src='../../assets/baby-sprites/baby_sprites_black.svg', v-if='spriteDetails.tokenId % 6 === 1')
    img(src='../../assets/baby-sprites/baby_sprites_blue.svg', v-if='spriteDetails.tokenId % 6 === 2')
    img(src='../../assets/baby-sprites/baby_sprites_green.svg', v-if='spriteDetails.tokenId % 6 === 3')
    img(src='../../assets/baby-sprites/baby_sprites_orange.svg', v-if='spriteDetails.tokenId % 6 === 4')
    img(src='../../assets/baby-sprites/baby_sprites_yellow.svg', v-if='spriteDetails.tokenId % 6 === 5')
  div(v-else-if='!readyToEvolve && spriteDetails.evolution === 1')
    img(src='../../assets/adolescents/sprite_adolescent_1_light.svg', v-if='sprite.tokenId % 6 === 0')
    img(src='../../assets/adolescents/sprite_adolescent_1_dark.svg', v-if='sprite.tokenId % 6 === 1')
    img(src='../../assets/adolescents/sprite_adolescent_1_winter.svg', v-if='sprite.tokenId % 6 === 2')
    img(src='../../assets/adolescents/sprite_adolescent_1_spring.svg', v-if='sprite.tokenId % 6 === 3')
    img(src='../../assets/adolescents/sprite_adolescent_1_autumn.svg', v-if='sprite.tokenId % 6 === 4')
    img(src='../../assets/adolescents/sprite_adolescent_1_summer.svg', v-if='sprite.tokenId % 6 === 5')
  evolve(v-else, :sprite='sprite')
</template>

<style scoped>
  img {
    width: 100%;
    max-height: 60px;
    min-height: 60px;
    display: block;
    margin: 0 auto;
  }

  .large img {
    max-height: 110px;
  }
</style>

<script>
import Evolve from './Evolve';

import evolveMixin from '../../mixins/evolve';

export default {
  props: ['sprite', 'size'],
  mixins: [evolveMixin],
  components: {
    Evolve,
  },
  computed: {
    spriteDetails() {
      let tokenId = this.sprite.spriteTokenId || this.sprite.tokenId;
      if (tokenId && tokenId.indexOf && tokenId.indexOf('-') !== -1) tokenId = undefined;

      return {
        tokenId,
        name: this.sprite.spriteName || this.sprite.name || 'Sprite 1',
        freeType: this.sprite.spriteFreeType || this.sprite.freeType || '',
        evolution: this.sprite.evolution || 0,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpriteRender.vue